type OwnerConsoleCredentialMember = {
  credentialStatus?: 'activationRequired' | 'credentialsReady' | null
}

export const getOwnerConsoleCredentialStatusKey = (member: OwnerConsoleCredentialMember | null | undefined) => {
  return member?.credentialStatus === 'credentialsReady'
    ? 'ownerConsole.members.credentialsReady'
    : 'ownerConsole.members.activationRequired'
}

export const getOwnerConsoleCredentialActionKey = (member: OwnerConsoleCredentialMember | null | undefined) => {
  return member?.credentialStatus === 'credentialsReady'
    ? 'ownerConsole.action.issuePasswordReset'
    : 'ownerConsole.action.issueActivation'
}

export const ownerConsoleMemberNeedsActivation = (member: OwnerConsoleCredentialMember | null | undefined) => {
  return member?.credentialStatus !== 'credentialsReady'
}
type OwnerConsoleStatusMember = OwnerConsoleCredentialMember & {
  status?: 'active' | 'revoked'
  hasPin?: boolean
  hasSignIn?: boolean
  neverSignedIn?: boolean
}

export type OwnerConsoleMemberStatus = {
  labelKey:
    | 'ownerConsole.status.revoked'
    | 'ownerConsole.members.status.pinReady'
    | 'ownerConsole.members.status.noPin'
    | 'ownerConsole.members.status.canSignIn'
    | 'ownerConsole.members.status.neverSignedIn'
    | 'ownerConsole.members.status.needsActivation'
  tone: 'ok' | 'warn' | 'revoked'
  hintKey?: 'ownerConsole.members.status.needsActivationHint' | 'ownerConsole.members.status.noPinHint'
}

/**
 * Findings #121 (rehearsal 2): one plain status per member instead of four
 * labels (Activo / Activación requerida / Tokens activos / Tokens revocados).
 * A PIN-only operator never signs in on the web, so it is described by its
 * PIN; web and crew-phone accounts by whether they can sign in yet.
 * `hasSignIn` is missing from older API builds → treated as a sign-in account.
 */
export const getOwnerConsoleMemberStatus = (member: OwnerConsoleStatusMember): OwnerConsoleMemberStatus => {
  if (member.status === 'revoked') return { labelKey: 'ownerConsole.status.revoked', tone: 'revoked' }
  if (member.hasSignIn === false) {
    return member.hasPin
      ? { labelKey: 'ownerConsole.members.status.pinReady', tone: 'ok' }
      : { labelKey: 'ownerConsole.members.status.noPin', tone: 'warn', hintKey: 'ownerConsole.members.status.noPinHint' }
  }
  if (member.credentialStatus !== 'credentialsReady') {
    return { labelKey: 'ownerConsole.members.status.needsActivation', tone: 'warn', hintKey: 'ownerConsole.members.status.needsActivationHint' }
  }
  // Findings #169: an account made by bootstrapAdmin.ts or never used yet.
  return member.neverSignedIn
    ? { labelKey: 'ownerConsole.members.status.neverSignedIn', tone: 'warn' }
    : { labelKey: 'ownerConsole.members.status.canSignIn', tone: 'ok' }
}
